import multidivice from '../assets/images/welcome/multidivice.svg';
import safety from '../assets/images/welcome/safety.svg';
import saveplace from '../assets/images/welcome/saveplace.svg';
import realtime from '../assets/images/welcome/realtime.svg';
import lifeInsurance from '../assets/images/apsecure/seguro-por-muerte.svg';
import incapacitates from '../assets/images/apsecure/seguro-por-discapacidad.svg';
import lostDocument from '../assets/images/apsecure/seguro-por-perdida-documentos.svg';
import medicalAssistence from '../assets/images/apsecure/asistencia-medica.svg';
import accident from '../assets/images/apsecure/accident.svg';
import colors from '../assets/styles/colors';
import { BsCloudDownload, BsCloudUpload } from 'react-icons/bs';
import { VscSmiley } from 'react-icons/vsc';

export const months = {
  0: "",
  1: "Ene",
  2: "Feb",
  3: "Mar",
  4: "Abr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Ago",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dic",
};

export const credits = [
  {
    id: 1,
    idBackend: 4,
    nombre: "Compra de cartera",
  },    
  {
    id: 3,
    idBackend: 1,
    nombre: "Libre inversión",
  },
  {
    id: 5,
    idBackend: 5,
    nombre: "Retanqueo compra de cartera",
  },  
  {
    id: 7,
    idBackend: 3,
    nombre: "Retanqueo libre inversión",
  }
];

export const creditLinesBack = [
  {
    id: "1",
    nombre: "Libre inversión",
  },
  {
    id: "4",
    nombre: "Compra de cartera",
  },
  {
    id: "3",
    nombre: "Retanqueo Libre Inversión",
  },
  {
    id: "5",
    nombre: "Retanqueo Compra de Cartera",
  },
  {
    id: "6",
    nombre: "Educación",
  },
  {
    id: "7",
    nombre: "Actividades Productivas",
  }
];

export const agileSimulatorSteps = {
  DEFAULT: 0,
  AGILE_SIMULATOR: 1,
};

export const simuladorRetanqueoSteps = {
  DEFAULT: 0,
  SIMULADOR_RETANQUEO: 1,
};

export const habeasDataSenderSteps = {
  DEFAULT: 0,
  IDENTIFICATION_FORM: 1,
  CONTACT_FORM: 2,
};

export const pagosSteps = {
  DEFAULT: 0,
  LIQUIDACION: 1,
  PLANILLA: 2,
};

export const simulatorSteps = {
  DEFAULT: 0,
  PRICE_VALUE_TO_SOLICITATE: 1,
  CLIENT_DATA: 2,
  RESULT: 3,
};

export const clientRegistrationSteps = {
  DEFAULT: 0,
  IDENTITY_FOTO: 1,
  REGISTRATION: 2,
  ADITIONAL_DATA: 3,
  CLIENT_PHOTO: 4,
  PROSPECTING: 5,
  CONFORMITY: 6
};

export const globalDebtSteps = {
  DEFAULT: 0,
  BASIC_REQUESTING_INFORMATION: 1,
  FINANCE_DATA_ONE: 2,
  CENTRAL_INFORMATION: 3,
  OTHER_CERTIFIED_INCOME: 4,
};

export const meansOfDisbursementSteps = {
  DEFAULT: 0,
  DISBURSEMENT_MODALITY: 1,
  SUGGESTED_CUSTOMER_SEGMENT_AND_TYPE: 2,
};

export const dataSolicitationSteps = {
  DEFAULT: 0,
  BASIC_DATA: 1,
  //ADITIONAL_DATA: 2,
  //COMPLEMENT_DATA: 3,
  WORK_DATA: 2,
  CREDIT_DATA: 3,
  RESULT: 4,
};

export const identificationType = {
  cc: {
    min: 9,
    max: 13,
  },
  ce: {
    min: 0,
    max: 10,
  },
};

export const numeroAfiliacionPensionado = {
  min: 12,
  max: 12
}

export const mortagePayments = {
  max: 99999999,
  min: 0,
  default: 1
}

export const contactMeans = [
  {
    id: 'ASESOR',
    nombre: 'Asesor de ExcelCredit'
  },
  {
    id: 'ASESOR_OTRA_ENTIDAD',
    nombre: 'Asesor de otra entidad'
  },
  {
    id: 'OFICINA',
    nombre: 'Directamente en la red de oficinas de ExcelCredit'
  },
  {
    id: 'EMPRESA_TRABAJO_CLIENTE',
    nombre: 'Entidad donde trabaja'
  },
  {
    id: 'EVENTO_COMERCIAL',
    nombre: 'Eventos comerciales'
  },  
  {
    id: 'INTERNET',
    nombre: 'Internet'
  },
  {
    id: 'PAGINA_WEB',
    nombre: 'Página web ExcelCredit'
  },    
  {
    id: 'PRENSA',
    nombre: 'Publicidad en prensa'
  },
  {
    id: 'RADIO',
    nombre: 'Publicidad en radio'
  },    
  {
    id: 'RED_SOCIAL',
    nombre: 'Redes sociales'
  },    
  {
    id: 'REFERENCIA_CLIENTE',
    nombre: 'Referencia familiar, amigo, conocido'
  },
  {
    id: 'VOLANTE',
    nombre: 'Volantes'
  }
]

export const idTypes = [
  {
    id: 'NUEVA',
    nombre: 'Cédula nueva'
  },
  {
    id: 'VIEJA',
    nombre: 'Cédula antigua'
  }
]

export const attemptsOtp = {
  max: 3,
};

export const meansOfDisbursementStepsCheckboxFields = [
  {
    id: 'ACH',
    name: "ACH (Transferencia Bancaria)",
  },
  {
    id: 'PAGO_MASIVO',
    name: "Pago masivo (efectivo)",
  },
  {
    id: 'Transferencia',
    name: "TDP (Tarjeta débito prepago)",
  },
];

export const residenceTypes = [
  {
    id: "FAMILIAR",
    nombre: "Familiar",
  },
  {
    id: "ARRIENDO",
    nombre: "Arriendo",
  },
  {
    id: "PROPIA",
    nombre: "Propia",
  },
];

export const accountTypes = [
  {
    id: "AHORROS",
    name: "Ahorros",
  },
  {
    id: "CORRIENTE",
    name: "Corriente",
  },
];

export const clientTypes = [
  {
    id: "Producto AAA",
    nombre: "AAA",
  },
  {
    id: "Producto Reportado",
    nombre: "Reportado",
  },
];

export const identityValidationSteps = {
  DEFAULT: 0,
  WAIT_FOR_VALIDATION: 1
}

export const documentSigningSteps = {
  DEFAULT: 0,
  //DIGITAL_DOCUMENTS: 1,
  //DOWNLOAD_DOCUMENTS: 1,
  UPLOAD_DOCUMENTS: 1
}

export const statusSituation = {
  SIMULACION_INICIAL: {
    pathname: '/admin/simulator'
  },
  SIN_CAPACIDAD_PAGO: {
    pathname: '/admin/simulator'
  },
  //finalizou o 3 step do registro do cliente
  INICIADO_DIGICREDITO: {
    pathname: '/admin/client-registration',
    step: clientRegistrationSteps.ADITIONAL_DATA,
    backStep: false
  },
  //na parte mobile se a foto do cliente foi recusada pelo serviço de terceiros
  IDENTIDAD_CLIENTE_RECHAZADA: {
    pathname: '/admin/dashboard'
  },
  //cliente recusou os termos
  CLIENTE_RECHAZO_PROSPECCION: {
    pathname: '/admin/dashboard'
  },
  //espero que tenga validada la identidad del cliente
  EN_ESPERA_VALIDACION_IDENTIDAD: {
    pathname: '/admin/identity-validation'
  },
  //se validó la identidad del cliente
  VALIDACION_IDENTIDAD_EXITOSA: {
    pathname: '/admin/client-registration',
    step: clientRegistrationSteps.IDENTITY_FOTO
  },
  //
  EN_REGISTRO_CLIENTE: {
    pathname: '/admin/client-registration',
    step: clientRegistrationSteps.IDENTITY_FOTO
  },
  // ainda não aceitou os termos ( depois do registro do cliente )
  EN_ESPERA_AUTORIZACION_OTP: {
    pathname: '/admin/client-registration',
    step: clientRegistrationSteps.PROSPECTING
  },
  // aceitou os termos com sucesso depois do serviço EN_ESPERA_AUTORIZACION_OTP
  PENDIENTE_PROSPECCION: {
    pathname: '/admin/client-registration',
    step: clientRegistrationSteps.PROSPECTING,
    validatingComplience: true
  },

  PENDIENTE_DOCUMENTOS: {
    pathname: '/admin/prospeccion-cliente'
  },
  EN_VALIDACION_PROSPECCION: {
    pathname: '/admin/prospeccion-cliente'
  },
  VALIDACION_DOCUMENTOS: {
    pathname: '/admin/prospeccion-cliente'
  },
  VALIDACION_ALERTAS: {
    pathname: '/admin/prospeccion-cliente'
  },
  PENDIENTE_DOCUMENTOS_COMPLIANCE: {
    pathname: '/admin/prospeccion-cliente'
  },
  PENDIENTE_DOCUMENTOS_CENTRALES: {
    pathname: '/admin/prospeccion-cliente'
  },
  PENDIENTE_DOCUMENTOS_TRUORA: {
    pathname: '/admin/prospeccion-cliente'
  },
  INICIO_PROSPECCION_CAMUNDA: {
    pathname: '/admin/prospeccion-cliente'
  },
  CONSULTA_CENTRALES: {
    pathname: '/admin/prospeccion-cliente'
  },
  CONSULTA_TRUORA: {
    pathname: '/admin/prospeccion-cliente'
  },
  VALIDACION_CIFIN: {
    pathname: '/admin/prospeccion-cliente'
  },
  VALIDACION_DATACREDITO: {
    pathname: '/admin/prospeccion-cliente'
  },
  VALIDACION_TRUORA: {
    pathname: '/admin/prospeccion-cliente'
  },
  VALIDACION_DOCUMENTOS_COMPLIANCE: {
    pathname: '/admin/prospeccion-cliente'
  },
  VALIDACION_DOCUMENTOS_CENTRALES: {
    pathname: '/admin/prospeccion-cliente'
  },
  VALIDACION_DOCUMENTOS_TRUORA: {
    pathname: '/admin/prospeccion-cliente'
  },
  // validando os dados pelo serviço de terceiro
  VALIDACION_COMPLIANCE: {
    pathname: '/admin/prospeccion-cliente'
  },
  // verificou a conformidade e está pronta para seguir depois de PENDIENTE_PROSPECCION
  PROSPECCION_EXITOSA: {
    pathname: '/admin/client-registration',
    step: clientRegistrationSteps.PROSPECTING,
  },

  PROSPECCION_CLIENTE_EXITOSA: {
    pathname: '/admin/client-registration',
    step: clientRegistrationSteps.CONFORMITY,
  },

  PENDIENTE_SIMULACION_FINAL_CREDITO: {
    pathname: '/admin/client-registration',
    step: clientRegistrationSteps.CONFORMITY,
  },
  EN_PROCESO_CALCULO_ENDEUDAMIENTO: {
    pathname: '/admin/global-debit'
  },
  CALCULO_ENDEUDAMIENTO_EJECUTADO: {
    pathname: '/admin/means-of-disbursement'
  },
  EN_SELECCION_MEDIO_DESEMBOLSO: {
    pathname: '/admin/means-of-disbursement'
  },
  EN_REGISTRO_DATOS_ADICIONALES_CLIENTE: {
    pathname: '/admin/data-solicitation',
    step: dataSolicitationSteps.BASIC_DATA
  },
  EN_SIMULACION_FINAL_ASESOR: {
    pathname: '/admin/data-solicitation',
    step: dataSolicitationSteps.CREDIT_DATA,
    backStep: false
  },
  EN_ESPERA_EXCEPCIONES: {
    pathname: '/admin/exception'
  },
  EN_DECISION_SEGURO_AP: {
    pathname: '/admin/ap-secure'
  },
  EN_PROCESO_NOTIFICAR_EXCEPCIONES: {
    pathname: '/admin/processed-exceptions'
  },
  EN_REGISTRO_REFERENCIAS: {
    pathname: '/admin/references'
  },
  EN_REGISTRO_SEGURO_VIDA: {
    pathname: '/admin/life-insurance'
  },
  EN_REGISTRO_OPERACIONES_INTERNACIONALES: {
    pathname: '/admin/international-operations'
  },
  EN_ESPERA_FIRMA_DOCUMENTOS: {
    pathname: '/admin/document-signing'
  },
  FINALIZADO_FIRMA_DOCUMENTOS: {
    pathname: '/admin/document-signing',
    step: documentSigningSteps.DOWNLOAD_DOCUMENTS
  }
}

export const welcomeSliderSteps = [
  {
    image: multidivice,
    alt: 'multiplatform',
    title: 'Amigable Interfaz multiplataforma',
    description: 'Apoya y facilita el proceso del crédito casi desde cualquier lugar con red de datos disponible, desde tu celular, tablet o computador.'
  },
  {
    image: safety,
    alt: 'smart and safe processes',
    title: 'Procesos inteligentes y seguros',
    description: 'Atención dinámica, intuitiva y segura en el proceso de crédito, gracias a las validaciones en tiempo real, bajo servicios eficientes con la mejor tecnología.'
  },
  {
    image: saveplace,
    title: 'Retoma de solicitud',
    description: 'Puedes retomar tu solicitud de crédito desde DigiCrédito, como también guardar y dar trámite a las Simulaciones guardadas.'
  },
  {
    image: realtime,
    title: 'En tiempo real',
    description: 'Consulta y lleva seguimiento de los diferentes procesos de crédito que tienes, para brindar un servicio más eficiente con tus clientes.'
  },
];

export const welcomeDownloadDocuments = [
  {
    id: 1,
    image: <BsCloudDownload color={colors.textPrimary} size={22} />,
    description: 'Descarga los siguientes documentos para que sean firmados por el Cliente.',
    alt: 'Download documents',
    backgroundIcon: colors.grayLight
  },
  {
    id: 2,
    image: <BsCloudUpload color={colors.textPrimary} size={22} />,
    description: 'Luego adjuntalos mediante una foto o formato tipo PDF.',
    alt: 'Upload documents',
    backgroundIcon: colors.grayLight
  },
  {
    id: 3,
    image: <VscSmiley color={colors.white} size={22} />,
    description: 'Finalmente radica la solicitud del Crédito.',
    alt: 'End credit process',
    backgroundIcon: colors.textHyperlink
  },
]

export const maritalStatus = [
  {
    id: 'DIVORCIADO',
    nombre: 'Divorciada/o'
  },
  {
    id: 'VIUDO',
    nombre: 'Viuda/o'
  },
  {
    id: 'SOLTERO',
    nombre: 'Soltera/o'
  },
  {
    id: 'CASADO',
    nombre: 'Casada/o'
  },
];

export const segments = [
  {
    id: 'ACTIVO',
    nombre: 'Activo'
  },
  {
    id: 'PENSIONADO',
    nombre: 'Pensionado'
  }
]

export const conformityStatus = [
  {
    id: 1,
    description: 'COMPLETADO'
  },
  {
    id: 2,
    description: 'PROCESANDO'
  },
  {
    id: 3,
    description: 'ERROR'
  }
];

export const internationalOperationsSteps = {
  DEFAULT: 0,
  INTERNATIONAL_OPERATIONS: 1,
  POLITICALLY_EXPOSED_PERSON: 2
};

export const transationTypes = [
  {
    id: 'EXPORTACIONES',
    nombre: 'Exportaciones'
  },
  {
    id: 'IMPORTACIONES',
    nombre: 'Importaciones'
  },
  {
    id: 'INVERSIONES',
    nombre: 'Inversiones'
  },
  {
    id: 'OTRA',
    nombre: 'Otra'
  },
  {
    id: 'PRESTAMOS',
    nombre: 'Préstamos M/E'
  },
  {
    id: 'GIROS',
    nombre: 'Giros'
  },
]

export const apSecureSteps = {
  DEFAULT: 0,
  CHOSE_OPTION: 1,
  BENEFICIARY: 2,
  TAKER: 3,
  CHOSE_PLAN: 4
}

export const apSecureSliderSteps = [
  {
    image: lifeInsurance,
    alt: 'life insurance',
    description: 'En caso de Muerte Accidental aplicaría un pago entre $10 M a $50 M a los beneficiarios relacionados en la solicitud o los dispuestos por ley. Aplica según plan tomando.'
  },
  {
    image: incapacitates,
    alt: 'incapacitates',
    description: 'Cobertura de incapacidad total o permanente, o en caso de desmembración accidental del asegurado recibirá un pago entre $10 M a $50 M. Aplica según plan tomando.'
  },
  {
    image: accident,
    alt: 'accident',
    description: 'Rotura de huesos por accidente $1.5 M, reembolso de gastos por accidente $1 M y renta de gastos de hogar por muerte accidental $2 M. Aplica para el Plan 2.'
  },
  {
    image: medicalAssistence,
    alt: 'medical asssitence',
    description: 'Asistencia médica, servicio de ambulancia hasta 2 veces durante la vigencia del seguro, ayuda personal y de hogar. Aplica para todos los planes.'
  },
]

export const apSecureChoseOptions = [
  {
    id: 1,
    name: 'Vinculado (tomador del crédito)'
  },
  /*{
    id: 2,
    name: 'No vinculado (diferente al tomador)'
  }*/
]
export const exceptionSteps = {
  DEFAULT: 0,
  EXCEPTIONS: 1
}

export const otherCausalIdType = {
  id: 49,
  nombre: 'Otros'
};

export const exceptionStatus = {
  EN_PROCESO: {
    id: 1,
    nombre: 'En proceso',
    background: colors.textPrimary
  },
  TRAMITADA: {
    id: 2,
    nombre: 'Tramitada',
    background: colors.bgSecondary
  },
  APROBADA: {
    id: 3,
    nombre: 'Aprobada',
    background: colors.textHyperlink
  },
  NEGADA: {
    id: 4,
    nombre: 'Negada',
    background: colors.bgDanger
  },
  APROBADA_PENDIENTE_DOCUMENTAL: {
    id: 5,
    nombre: 'Aprobada - Pendiente Documental',
    background: colors.bgPrimary
  },
  DEVUELTA: {
    id: 6,
    nombre: 'Devuelta',
    background: colors.bgDarkOrange
  }
}

export const referencesSteps = {
  DEFAULT: 0,
  PERSONAL: 1,
  FAMILY: 2
}

export const personalRelationShip = [
  {
    id: 'AMIGO',
    nombre: 'Amigo'
  },
  {
    id: 'COMPANERO',
    nombre: 'Compañero'
  },
  {
    id: 'CONOCIDO',
    nombre: 'Conocido'
  },
  {
    id: 'OTRO',
    nombre: 'Otro'
  },
  {
    id: 'SOCIO',
    nombre: 'Socio'
  },
  {
    id: 'VECINO',
    nombre: 'Vecino'
  },
]

export const zonasRurales = [
  { id: 'AD', nombre: 'ADMINISTRACIÓN' },
  { id: 'ADL', nombre: 'ADELANTE' },
  { id: 'AER', nombre: 'AEROPUERTO' },
  { id: 'AG', nombre: 'AGENCIA' },
  { id: 'AGP', nombre: 'AGRUPACIÓN' },
  { id: 'AL', nombre: 'ALTILLO' },
  { id: 'ALD', nombre: 'AL LADO' },
  { id: 'ALM', nombre: 'ALMACÉN' },
  { id: 'APTDO', nombre: 'APARTADO' },
  { id: 'ATR', nombre: 'ATRÁS' },
  { id: 'AVIAL', nombre: 'ANILLO VIAL' },
  { id: 'BG', nombre: 'BODEGA' },
  { id: 'BL', nombre: 'BLOQUE' },
  { id: 'BLV', nombre: 'BOULEVARD' },
  { id: 'C', nombre: 'CORREGIMIENTO' },
  { id: 'CA', nombre: 'CASA' },
  { id: 'CAS', nombre: 'CASERÍO' },
  { id: 'CD', nombre: 'CIUDADELA' },
  { id: 'CEL', nombre: 'CÉLULA' },
  { id: 'CEN', nombre: 'CENTRO' },
  { id: 'CIR', nombre: 'CIRCULAR' },
  { id: 'CLJ', nombre: 'CALLEJÓN' },
  { id: 'CN', nombre: 'CAMINO' },
  { id: 'CRT', nombre: 'CARRETERA' },
  { id: 'DP', nombre: 'DEPÓSITO' },
  { id: 'DPTO', nombre: 'DEPARTAMENTO' },
  { id: 'DS', nombre: 'DEPÓSITO SÓTANO' },
  { id: 'ED', nombre: 'EDIFICIO' },
  { id: 'EN', nombre: 'ENTRADA' },
  { id: 'ES', nombre: 'ESCALERA' },
  { id: 'ESQ', nombre: 'ESQUINA' },
  { id: 'ET', nombre: 'ETAPA' },
  { id: 'EX', nombre: 'EXTERIOR' },
  { id: 'FCA', nombre: 'FINCA' },
  { id: 'GJ', nombre: 'GARAJE' },
  { id: 'GS', nombre: 'GARAJE SÓTANO' },
  { id: 'GT', nombre: 'GLORIETA' },
  { id: 'HC', nombre: 'HACIENDA' },
  { id: 'HG', nombre: 'HANGAR' },
  { id: 'IN', nombre: 'INTERIOR' },
  { id: 'IP', nombre: 'INSPECCIÓN DE POLICÍA' },
  { id: 'IPD', nombre: 'INSPECCIÓN DEPARTAMENTAL' },
  { id: 'IPM', nombre: 'INSPECCIÓN MUNICIPAL' },
  { id: 'KM', nombre: 'KILÓMETRO' },
  { id: 'LC', nombre: 'LOCAL' },
  { id: 'LM', nombre: 'LOCAL MEZZANINE' },
  { id: 'LT', nombre: 'LOTE' },
  { id: 'MD', nombre: 'MÓDULO' },
  { id: 'MJ', nombre: 'MOJÓN' },
  { id: 'MLL', nombre: 'MUELLE' },
  { id: 'MN', nombre: 'MEZZANINE' },
  { id: 'MZ', nombre: 'MANZANA' },
  { id: 'NOMBRE VIA', nombre: 'VÍAS DE NOMBRE COMÚN' },
  { id: 'P', nombre: 'PISO' },
  { id: 'PA', nombre: 'PARCELA' },
  { id: 'PAR', nombre: 'PARQUE' },
  { id: 'PD', nombre: 'PREDIO' },
  { id: 'PJ', nombre: 'PASAJE' },
  { id: 'PL', nombre: 'PLANTA' },
  { id: 'PN', nombre: 'PUENTE' },
  { id: 'POR', nombre: 'PORTERÍA' },
  { id: 'POS', nombre: 'POSTE' },
  { id: 'PQ', nombre: 'PARQUEADERO' },
  { id: 'PRJ', nombre: 'PARAJE' },
  { id: 'PS', nombre: 'PASEO' },
  { id: 'PT', nombre: 'PUESTO' },
  { id: 'RP', nombre: 'ROUND POINT' },
  { id: 'SD', nombre: 'SALIDA' },
  { id: 'SEC', nombre: 'SECTOR' },
  { id: 'SL', nombre: 'SOLAR' },
  { id: 'SM', nombre: 'SÚPER MANZANA' },
  { id: 'SUITE', nombre: 'SUITE' },
  { id: 'TER', nombre: 'TERMINAL' },
  { id: 'TERPLN', nombre: 'TERRAPLÉN' },
  { id: 'TZ', nombre: 'TERRAZA' },
  { id: 'UN', nombre: 'UNIDAD' },
  { id: 'UR', nombre: 'UNIDAD RESIDENCIAL' },
  { id: 'URB', nombre: 'URBANIZACIÓN' },
  { id: 'VRD', nombre: 'VEREDA' },
  { id: 'VTE', nombre: 'VARIANTE' },
  { id: 'ZF', nombre: 'ZONA FRANCA' },
  { id: 'ZN', nombre: 'ZONA' },
];

export const AddressNomenclatura1 = [
  {
      "id": "AC",
      "nombre": "AVENIDA CALLE"
  },
  {
      "id": "AD",
      "nombre": "ADMINISTRACIÓN"
  },
  {
      "id": "ADL",
      "nombre": "ADELANTE"
  },
  {
      "id": "AER",
      "nombre": "AEROPUERTO"
  },
  {
      "id": "AG",
      "nombre": "AGENCIA"
  },
  {
      "id": "AGP",
      "nombre": "AGRUPACIÓN"
  },
  {
      "id": "AK",
      "nombre": "AVENIDA CARRERA"
  },
  {
      "id": "AL",
      "nombre": "ALTILLO"
  },
  {
      "id": "ALD",
      "nombre": "AL LADO"
  },
  {
      "id": "ALM",
      "nombre": "ALMACÉN"
  },
  {
      "id": "AP",
      "nombre": "APARTAMENTO"
  },
  {
      "id": "APTDO",
      "nombre": "APARTADO"
  },
  {
      "id": "ATR",
      "nombre": "ATRÁS"
  },
  {
      "id": "AUT",
      "nombre": "AUTOPISTA"
  },
  {
      "id": "AV",
      "nombre": "AVENIDA"
  },
  {
      "id": "AVIAL",
      "nombre": "ANILLO VIAL"
  },
  {
      "id": "BG",
      "nombre": "BODEGA"
  },
  {
      "id": "BL",
      "nombre": "BLOQUE"
  },
  {
      "id": "BLV",
      "nombre": "BOULEVARD"
  },
  {
      "id": "BRR",
      "nombre": "BARRIO"
  },
  {
      "id": "C",
      "nombre": "CORREGIMIENTO"
  },
  {
      "id": "CA",
      "nombre": "CASA"
  },
  {
      "id": "CAS",
      "nombre": "CASERÍO"
  },
  {
      "id": "CC",
      "nombre": "CENTRO COMERCIAL"
  },
  {
      "id": "CD",
      "nombre": "CIUDADELA"
  },
  {
      "id": "CEL",
      "nombre": "CÉLULA"
  },
  {
      "id": "CEN",
      "nombre": "CENTRO"
  },
  {
      "id": "CIR",
      "nombre": "CIRCULAR"
  },
  {
      "id": "CL",
      "nombre": "CALLE"
  },
  {
      "id": "CLJ",
      "nombre": "CALLEJÓN"
  },
  {
      "id": "CN",
      "nombre": "CAMINO"
  },
  {
      "id": "CON",
      "nombre": "CONJUNTO RESIDENCIAL"
  },
  {
      "id": "CONJ",
      "nombre": "CONJUNTO"
  },
  {
      "id": "CR",
      "nombre": "CARRERA"
  },
  {
      "id": "CRT",
      "nombre": "CARRETERA"
  },
  {
      "id": "CRV",
      "nombre": "CIRCUNVALAR"
  },
  {
      "id": "CS",
      "nombre": "CONSULTORIO"
  },
  {
      "id": "DG",
      "nombre": "DIAGONAL"
  },
  {
      "id": "DP",
      "nombre": "DEPÓSITO"
  },
  {
      "id": "DPTO",
      "nombre": "DEPARTAMENTO"
  },
  {
      "id": "DS",
      "nombre": "DEPÓSITO SÓTANO"
  },
  {
      "id": "ED",
      "nombre": "EDIFICIO"
  },
  {
      "id": "EN",
      "nombre": "ENTRADA"
  },
  {
      "id": "ES",
      "nombre": "ESCALERA"
  },
  {
      "id": "ESQ",
      "nombre": "ESQUINA"
  },
  {
      "id": "ESTE",
      "nombre": "ESTE"
  },
  {
      "id": "ET",
      "nombre": "ETAPA"
  },
  {
      "id": "EX",
      "nombre": "EXTERIOR"
  },
  {
      "id": "FCA",
      "nombre": "FINCA"
  },
  {
      "id": "GJ",
      "nombre": "GARAJE"
  },
  {
      "id": "GS",
      "nombre": "GARAJE SÓTANO"
  },
  {
      "id": "GT",
      "nombre": "GLORIETA"
  },
  {
      "id": "HC",
      "nombre": "HACIENDA"
  },
  {
      "id": "HG",
      "nombre": "HANGAR"
  },
  {
      "id": "IN",
      "nombre": "INTERIOR"
  },
  {
      "id": "IP",
      "nombre": "INSPECCIÓN DE POLICÍA"
  },
  {
      "id": "IPD",
      "nombre": "INSPECCIÓN DEPARTAMENTAL"
  },
  {
      "id": "IPM",
      "nombre": "INSPECCIÓN MUNICIPAL"
  },
  {
      "id": "KM",
      "nombre": "KILÓMETRO"
  },
  {
      "id": "LC",
      "nombre": "LOCAL"
  },
  {
      "id": "LM",
      "nombre": "LOCAL MEZZANINE"
  },
  {
      "id": "LT",
      "nombre": "LOTE"
  },
  {
      "id": "MD",
      "nombre": "MÓDULO"
  },
  {
      "id": "MJ",
      "nombre": "MOJÓN"
  },
  {
      "id": "MLL",
      "nombre": "MUELLE"
  },
  {
      "id": "MN",
      "nombre": "MEZZANINE"
  },
  {
      "id": "MZ",
      "nombre": "MANZANA"
  },
  {
      "id": "NOMBRE VIA",
      "nombre": "VÍAS DE NOMBRE COMÚN"
  },
  {
      "id": "NORTE",
      "nombre": "NORTE"
  },
  {
      "id": "O",
      "nombre": "ORIENTE"
  },
  {
      "id": "OCC",
      "nombre": "OCCIDENTE"
  },
  {
      "id": "OESTE",
      "nombre": "OESTE"
  },
  {
      "id": "OF",
      "nombre": "OFICINA"
  },
  {
      "id": "P",
      "nombre": "PISO"
  },
  {
      "id": "PA",
      "nombre": "PARCELA"
  },
  {
      "id": "PAR",
      "nombre": "PARQUE"
  },
  {
      "id": "PD",
      "nombre": "PREDIO"
  },
  {
      "id": "PH",
      "nombre": "PENTHOUSE"
  },
  {
      "id": "PJ",
      "nombre": "PASAJE"
  },
  {
      "id": "PL",
      "nombre": "PLANTA"
  },
  {
      "id": "PN",
      "nombre": "PUENTE"
  },
  {
      "id": "POR",
      "nombre": "PORTERÍA"
  },
  {
      "id": "POS",
      "nombre": "POSTE"
  },
  {
      "id": "PQ",
      "nombre": "PARQUEADERO"
  },
  {
      "id": "PRJ",
      "nombre": "PARAJE"
  },
  {
      "id": "PS",
      "nombre": "PASEO"
  },
  {
      "id": "PT",
      "nombre": "PUESTO"
  },
  {
      "id": "PW",
      "nombre": "PARK WAY"
  },
  {
      "id": "RP",
      "nombre": "ROUND POINT"
  },
  {
      "id": "SA",
      "nombre": "SALÓN"
  },
  {
      "id": "SC",
      "nombre": "SALÓN COMUNAL"
  },
  {
      "id": "SD",
      "nombre": "SALIDA"
  },
  {
      "id": "SEC",
      "nombre": "SECTOR"
  },
  {
      "id": "SL",
      "nombre": "SOLAR"
  },
  {
      "id": "SM",
      "nombre": "SÚPER MANZANA"
  },
  {
      "id": "SS",
      "nombre": "SEMISÓTANO"
  },
  {
      "id": "ST",
      "nombre": "SÓTANO"
  },
  {
      "id": "SUITE",
      "nombre": "SUITE"
  },
  {
      "id": "SUR",
      "nombre": "SUR"
  },
  {
      "id": "TER",
      "nombre": "TERMINAL"
  },
  {
      "id": "TERPLN",
      "nombre": "TERRAPLÉN"
  },
  {
      "id": "TO",
      "nombre": "TORRE"
  },
  {
      "id": "TV",
      "nombre": "TRANSVERSAL"
  },
  {
      "id": "TZ",
      "nombre": "TERRAZA"
  },
  {
      "id": "UN",
      "nombre": "UNIDAD"
  },
  {
      "id": "UR",
      "nombre": "UNIDAD RESIDENCIAL"
  },
  {
      "id": "URB",
      "nombre": "URBANIZACIÓN"
  },
  {
      "id": "VRD",
      "nombre": "VEREDA"
  },
  {
      "id": "VTE",
      "nombre": "VARIANTE"
  },
  {
      "id": "ZF",
      "nombre": "ZONA FRANCA"
  },
  {
      "id": "ZN",
      "nombre": "ZONA"
  }
];

export const AddressNomenclatura2 = [
  {
      "id": "A",
      "nombre": "A"
  },
  {
      "id": "B",
      "nombre": "B"
  },
  {
      "id": "C",
      "nombre": "C"
  },
  {
      "id": "D",
      "nombre": "D"
  },
  {
      "id": "E",
      "nombre": "E"
  },
  {
      "id": "F",
      "nombre": "F"
  },
  {
      "id": "G",
      "nombre": "G"
  },
  {
      "id": "H",
      "nombre": "H"
  },
  {
      "id": "I",
      "nombre": "I"
  },
  {
      "id": "J",
      "nombre": "J"
  },
  {
      "id": "K",
      "nombre": "K"
  },
  {
      "id": "L",
      "nombre": "L"
  },
  {
      "id": "M",
      "nombre": "M"
  },
  {
      "id": "N",
      "nombre": "N"
  },
  {
      "id": "O",
      "nombre": "O"
  },
  {
      "id": "P",
      "nombre": "P"
  },
  {
      "id": "Q",
      "nombre": "Q"
  },
  {
      "id": "R",
      "nombre": "R"
  },
  {
      "id": "S",
      "nombre": "S"
  },
  {
      "id": "T",
      "nombre": "T"
  },
  {
      "id": "U",
      "nombre": "U"
  },
  {
      "id": "V",
      "nombre": "V"
  },
  {
      "id": "W",
      "nombre": "W"
  },
  {
      "id": "X",
      "nombre": "X"
  },
  {
      "id": "Y",
      "nombre": "Y"
  },
  {
      "id": "Z",
      "nombre": "Z"
  } 
];

export const AddressNomenclatura3 = [
  {
      "id": "CENTRO",
      "nombre": "CENTRO"
  },
  {
      "id": "ESTE",
      "nombre": "ESTE"
  },
  {
      "id": "NORTE",
      "nombre": "NORTE"
  },
  {
      "id": "OCCIDENTE",
      "nombre": "OCCIDENTE"
  },
  {
      "id": "OESTE",
      "nombre": "OESTE"
  },
  {
      "id": "ORIENTE",
      "nombre": "ORIENTE"
  },
  {
      "id": "SUR",
      "nombre": "SUR"
  },
  {
      "id": "VIA",
      "nombre": "VIA"
  },
  {
      "id": "ZONA",
      "nombre": "ZONA"
  }
];

export const AddressNomenclatura4 = [
  {
      "id": "0",
      "nombre": ""
  },
  {
      "id": "1",
      "nombre": "Bis"
  }
];

export const familyRelationShip = [
  {
    id: 'ABUELO',
    nombre: 'Abuelo'
  },
  {
    id: 'CONSUEGRO',
    nombre: 'Consuegro'
  },
  {
    id: 'CONYUGE',
    nombre: 'Cónyuge'
  },
  {
    id: 'CUÑADO',
    nombre: 'Cuñado'
  },
  {
    id: 'HERMANO',
    nombre: 'Hermano'
  },
  {
    id: 'HIJO',
    nombre: 'Hijo'
  },
  {
    id: 'MADRE',
    nombre: 'Madre'
  },
  {
    id: 'NUERA',
    nombre: 'Nuera'
  },
  {
    id: 'PADRE',
    nombre: 'Padre'
  },
  {
    id: 'PRIMO',
    nombre: 'Primo'
  },
  {
    id: 'SOBRINO',
    nombre: 'Sobrino'
  },
  {
    id: 'TIO',
    nombre: 'Tio'
  },
  {
    id: 'YERNO',
    nombre: 'Yerno'
  },
  {
    id: 'OTRO',
    nombre: 'Otro'
  },
]

export const actividadConjuge = [
  {
    id: 'AGRICULTURA',
    nombre: 'Agricultura'
  },
  {
    id: 'SERVICIOS_AGRICOLAS',
    nombre: 'Servicios agrícolas'
  },
  {
    id: 'CAZA',
    nombre: 'Caza'
  },
  {
    id: 'SILVICULTURA_PESCA',
    nombre: 'Silvicultura y pesca'
  },
  {
    id: 'MINAS',
    nombre: 'Minas'
  },
  {
    id: 'PETROLEO_CANTERAS',
    nombre: 'Petróleo / canteras'
  },
  {
    id: 'INDUSTRIA_MANUFACTURERA',
    nombre: 'Industria manufacturera'
  },
  {
    id: 'ELECTRICIDAD_GAS_AGUA',
    nombre: 'Electricidad / gas / agua'
  },
  {
    id: 'CONSTRUCCION',
    nombre: 'Construcción'
  },
  {
    id: 'COMERCIO_MAYOR',
    nombre: 'Comercio mayor'
  },
  {
    id: 'COMERCIO_MENOR',
    nombre: 'Comercio menor'
  },
  {
    id: 'TRANSPORTE',
    nombre: 'Transporte'
  },
  {
    id: 'ALMACENAMIENTO_COMUNICACIONES',
    nombre: 'Almacenamiento / comunicaciones'
  },
  {
    id: 'FINANZAS',
    nombre: 'Finanzas'
  },
  {
    id: 'SEGUROS',
    nombre: 'Seguros'
  },
  {
  id: 'BIENES_INMUEBLES',
    nombre: 'Bienes inmuebles'
  },
  {
  id: 'SERVICIOS_TECNICOS',
    nombre: 'Servicios técnicos'
  },
  {
  id: 'PROFESIONALES_OTROS',
    nombre: 'Profesionales otros'
  },
  {
  id: 'SERVICIOS_ESTATALES',
    nombre: 'Servicios estatales'
  },
  {
  id: 'SOCIALES',
    nombre: 'Sociales'
  },
  {
  id: 'PERSONALES_INTERNACIONALES',
    nombre: 'Personas internacionales'
  },
  {
  id: 'INSTITUCIONES_ASISTENCIA_SOCIAL',
    nombre: 'Instituciones asistencia social'
  },
  {
  id: 'ASOCIACIONES_COMERCIALES',
    nombre: 'Asociaciones comerciales'
  },
  {
  id: 'PROFESIONALES_LABORALES',
    nombre: 'Profesionales laborales'
  },
  {
  id: 'SERVICIOS_DIVERSION_ESPARCIMIENTO_SERVICIOS_CULTURALES',
    nombre: 'Servicios diversión y esparcimiento / Servicios culturales'
  },
  {
  id: 'SERVICIOS_PERSONALES_HOGAR',
    nombre: 'Servicios personales hogar'
  },
  {
  id: 'PENSIONADOS',
    nombre: 'Pensionados'
  },
  {
  id: 'JUBILADOS',
    nombre: 'Jubilados'
  },

]

export const parentescoTypes = [
  {
    id: "CONYUGE",
    nombre: "Cónyuge"
  },
  {
    id: "PADRE",
    nombre: "Padre"
  },
  {
    id: "MADRE",
    nombre: "Madre"
  },
  {
    id: "HIJO",
    nombre: "Hijo(a)"
  },
  {
    id: "HERMANO",
    nombre: "Hermano(a)"
  },
  {
    id: "ABUELO",
    nombre: "Abuelo(a)"
  },
  {
    id: "NIETO",
    nombre: "Nieto(a)"
  },
  {
    id: "SUEGRO",
    nombre: "Suegro(a)"
  },
  {
    id: "CUNADO",
    nombre: "Cuñado(a)"
  },
  {
    id: "PADRE_ADOPTANTE",
    nombre: "Padre adoptante"
  },
  {
    id: "MADRE_ADOPTANTE",
    nombre: "Madre adoptante"
  }
];

export const decimalPlaces = [
  {
    size: [1, 2, 3],
    nombre: ''
  },
  {
    size: [4, 5, 6],
    nombre: 'M'
  },
  {
    size: [7, 8, 9],
    nombre: 'Mil'
  },
  {
    size: [10, 11, 12],
    nombre: 'Mil Millones'
  }
]

export const tooltipSolicitudes = {
  '100% desembolsado' : 'Crédito en el cual culminó todo el proceso de otorgamiento, junto con su desembolso.',
  'Aplazado excepción' : 'Estado que se genera el crédito cuando excede uno de los límites que tiene parametrizado Abacus, bien sea de monto o de tasa.',
  'Aplazado por análisis' : 'Se origina cuando el crédito está en análisis y a su vez el analista de crédito le genera una devolución a la oficina.',
  'Aplazado por error de cartera' : 'Opción del sistema que agiliza el reingreso a la oficina, puesto que se crea de forma incorrecta la cartera, sin embargo le permite a la oficina editar o eliminar el registro de los valores que se hayan registrado inicialmente. Solo aplica cuando se requiere hacer un ajuste por parte de la oficina sobre estos valores.',
  'Cliente Desiste' : 'Cuando el cliente determina no continuar con el proceso del crédito. Aplica sobre procesos como: llamada de bienvenida, desembolso o en la etapa de servicio al cliente.',
  'Consulta rechazada' : 'Se presenta cuando el cliente no es sujeto de crédito o cuando no cumple con los requisitos mínimos para hacer la consulta de su información en la etapa de prospección.',
  'En análisis' : 'La solicitud se encuentra en proceso de revisión y aprobación por parte del analista de crédito.',
  'En llamada de bienvenida' : 'Notificación de condiciones de otorgamiento al cliente por vía telefónica.',
  'En visación' : 'La solicitud de crédito ya fue aprobada, el cliente ya aceptó condiciones y se encuentra en proceso de visación (autorización) con la pagaduria.',
  'En Visación de Paz y Salvos' : 'El crédito ha efectuado el desembolso de las compras de cartera y se encuentra pendiente de la entrega de paz y salvos y su validación para su autorización de giros de remanente.',
  'Negado' : 'Cuando el crédito ha sido negado en fábrica de crédito en cualquiera de las etapas que le corresponde.',
  'Negado en desembolso' : 'Cuando el crédito ha sido negado en fábrica de crédito en cualquiera de las etapas que le corresponde.',
  'Negado en visación' : 'Cuando el crédito ha sido negado en incorporaciones en visación.',
  'Negado por excepción rechazada' : 'Cuando el crédito ha sido negado por una excepción en el sistema no aprobada.',
  'Pdte Saneamiento o Remanente' : 'Cuando el crédito ya se encuentra aprobado y aceptado por el cliente y se está pendiente en realizar el saneamiento si lo tiene o el remanente.',
  'Pdte Solicitud Excepción' : 'Cuando el crédito requiere o excede uno de los límites que establece el sistema y requiere una excepción. Es solicitado por el asesor o la oficina.',
  'Pdte. desembolso carteras' : 'Cuando el crédito requiere o excede uno de los límites que establece el sistema y requiere una excepción. Solicitud realizada por el asesor o la oficina.',
  'Pdte. radicación' : 'Crédito que ya culminó todo el proceso de radicación en DigiCrédito y avanza hacia la etapa de revisión inicial.',
  'Pendiente aprobación por análisis' : 'La solicitud se encuentra en proceso de revisión y aprobación por parte del coordinador o director de crédito.',
  'Pendiente respuesta consulta' : 'Tiempo que tarda el MS de prospección desde que el usuario lanza la petición de consulta de prospección al cliente.',
  'Radicado' : 'Cuando el crédito se encuentra en gestión por parte de la oficina completando documentos y está en espera que la oficina genere la instrucción para avanzar a análisis.',
  'Rechazado' : 'Cuando el crédito ha sido negado en Fábrica de Crédito en cualquiera de las etapas que le corresponde.',
  'Rechazado por cliente' : 'Cuando el cliente desiste del crédito en cualquier parte del proceso. Aplica en procesos como: llamada de bienvenida, desembolso o en la etapa de servicio al cliente.',
  'Reliquidar desde llamada bienvenida' : 'Proceso en el cual el cliente solicita un cambio de condiciones en la etapa de llamada de bienvenida, a pesar que el crédito ya ha sido aprobado.',
  'Repetir llamada' : 'Desistimiento del crédito por parte del cliente, sin embargo la oficina logra un nuevo acercamiento con el cliente, para realizar una nueva llamada de aceptación de condiciones de crédito inicial.',
  'Validacion Compliance' : 'Solicitud que refleja en la prospección una coincidencia en listas restrictivas.',
  'Alerta centrales' : 'Solicitud que refleja en la prospección una coincidencia de alerta en centrales de riesgo.',
  'Cancelado por inconsistencias' : 'Cuando la solicitud de crédito ha sido cancelada por validaciones realizadas por parte de Excelcredit.',
  'Pendiente Respuesta consulta a centrales' : 'Cuando la solicitud se encuentra en espera de validación de un resultado de los servicios de centrales de riesgo.',
  'Negado por causal' : 'Rechazo de la solicitud de crédito con base en las políticas definidas por fabrica de crédito.',
  'Aplazado por monto máximo' : 'Solicitud a la cual se le ha dado un aplazamiento por la causal descrita.',
  'Pdte Simulación final de crédito' : 'Solicitud en curso en el flujo de proceso, etapa del simulador 2.'
};

export const CdtSteps = {
  DEFAULT: 0,
  WAITING_EMAIL_CONFIRMATION: 1,
  WAITING_HABEAS_DATA_REVIEW: 2,
  WAITING_IDENTITY_VALIDATION: 3,
  WAITING_IDENTITY_VALIDATION_PART2: 3, 
  WAITING_PERSONAL_DATA: 4,
  WAITING_ADDITIONAL_PERSONAL_DATA: 4,
  WAITING_TERMS_AND_CONDITIONS_REVIEW: 5,
  WAITING_COMPLIANCE_VALIDATION: 6,
  WAITING_PASSWORD: 7,
  WAITING_PAYMENT_REQUEST: 8,
  WAITING_PAYMENT_RESPONSE: 8 ,
  ACTIVE: 10,
  FINISHED: 10
};

export const CdtFrequency = {
  ANNUALIZED: "Anual",
  ONCE_AT_END: "Al vencimiento",
  MONTHLY: "Mensual",
  QUATERLY: "Cuatrimestral",
  SEMIANNUAL: "Semestral"
};

export const CreditDestination = {
  MEJORA_VIVIENDA: "Mejora vivienda",
  NEGOCIOS_EMPRESA: "Negocios/Empresa",
  EDUCACION: "Educación",
  SALUD: "Salud",
  COMPRA_VEHICULO: "Compra vehiculo",
  COMPRA_VIVIENDA: "Compra vivienda",
  MEJORA_VEHICULO: "Mejora Vehiculo",
  VIAJE: "Viaje"
};

export const CreditDestinationSelect = [
  {
    id: 'MEJORA_VIVIENDA',
    nombre: CreditDestination.MEJORA_VIVIENDA
  }, 
  {
    id: 'NEGOCIOS_EMPRESA',
    nombre: CreditDestination.NEGOCIOS_EMPRESA
  }, 
  {
    id: 'EDUCACION',
    nombre: CreditDestination.EDUCACION
  }, 
  {
    id: 'SALUD',
    nombre: CreditDestination.SALUD
  }, 
  {
    id: 'COMPRA_VEHICULO',
    nombre: CreditDestination.COMPRA_VEHICULO
  },
  {
    id: 'COMPRA_VIVIENDA',
    nombre: CreditDestination.COMPRA_VIVIENDA
  }, 
  {
    id: 'MEJORA_VEHICULO',
    nombre: CreditDestination.MEJORA_VEHICULO
  }, 
  {
    id: 'VIAJE',
    nombre: CreditDestination.VIAJE
  }
];

export const prospectionStates = {
  VALIDACION_DOCUMENTOS: [
    {title: 'Compliance', status: {text: 'Finalizado', color: colors.bgSecondary}, description: "El cliente no presenta alertas de compilance"},
  ],
  PENDIENTE_DOCUMENTOS: [
    {title: 'Compliance', status: {text: 'Pte. Documentos', color: colors.bgDarkOrange}, description: "Se requiere de uno o más documentos para subsanar alertas, para ver más haga clic"},
  ]
  
}

export const attachDocumentsStates = [
  'PENDIENTE_DOCUMENTOS_COMPLIANCE',
  'PENDIENTE_DOCUMENTOS_CENTRALES',
  'PENDIENTE_DOCUMENTOS_TRUORA',
  'PENDIENTE_DOCUMENTOS',
  'EN_VALIDACION_PROSPECCION'
]